var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNavbarPayments(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.18182 5.6H14.8182C15.1677 5.6 15.4 5.86257 15.4 6.125V12.875C15.4 13.1374 15.1677 13.4 14.8182 13.4H4.18182C3.83229 13.4 3.6 13.1374 3.6 12.875V6.125C3.6 5.86257 3.83229 5.6 4.18182 5.6Z",
    stroke: "white",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.5 11.5C10.6046 11.5 11.5 10.6046 11.5 9.5C11.5 8.39543 10.6046 7.5 9.5 7.5C8.39543 7.5 7.5 8.39543 7.5 9.5C7.5 10.6046 8.39543 11.5 9.5 11.5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 5.4C3.66863 5.4 3.4 5.66863 3.4 6V10.4H1.18182C0.762625 10.4 0.6 10.1309 0.6 10V3C0.6 2.86913 0.762626 2.6 1.18182 2.6H11.8182C12.2374 2.6 12.4 2.86913 12.4 3L12.4 5.4H4Z",
    stroke: "white",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavbarPayments);
export default __webpack_public_path__ + "static/media/navbar-payments.61bfedf0dd53d771a22d0d200a2bcf1a.svg";
export { ForwardRef as ReactComponent };